import { useCallback, useRef } from 'react';

// Copied from https://bitbucket.hotterpads.com/projects/RP/repos/rentals-js/browse/modules/rp-spa-mui/src/hooks/useDebouncedCallback.ts
// Once in the monorepo can remove this file and just use
// import { useDebouncedCallback } from '@zg-rentals/rp-spa-mui';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export function useDebouncedCallback(fn: (...args: Array<any>) => void, delay?: number) {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const debounced = useCallback(
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    (...args: any) => {
      if (timeoutRef.current != null) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        fn.call(null, ...args);
      }, delay ?? 250);
    },
    [delay, fn],
  );

  return debounced;
}
